import { useRecordContext } from 'react-admin';
import { Avatar } from '@mui/material';

export const AvatarPictureField = () => {

  const record = useRecordContext();
  if (!record) return null;
  if (record.properties?.image) {

    return (
      <Avatar
        alt={record.name}
        src={record.properties?.image}
        sx={{ width: 30, height: 30 }}
      />
    );

  }

  let initials = record.name?.match(/\b\w/g);
  if (!initials || initials.length < 2) {

    initials = ['A', 'B'];

  }
  const twoInitials = initials.length > 1 ? initials[0] + initials[initials.length - 1] : initials[0];
  return (
    <Avatar
      alt={record.name}
      sx={{ width: 30, height: 30, fontSize: '15px' }}
    >
      {twoInitials.toUpperCase()}
    </Avatar>
  );

};
